import apiClient from "./api";

/**
 * The game-server's QuickLogin backup status of a device, keyed by its
 * machine_id. It never carries account data.
 */
export interface DeviceQuickLogins {
  device_id: string;
  machine_id: string;
  /** False when the machine has no backup, or its last upload had no accounts. */
  exist: boolean;
  /** When the machine last updated its backup; null without one. */
  updatedAt: string | null;
}

const quickLoginService = {
  get: (deviceId: string) =>
    apiClient.get<DeviceQuickLogins>(`/devices/${deviceId}/quicklogins`),

  delete: (deviceId: string) =>
    apiClient.delete<void>(`/devices/${deviceId}/quicklogins`),
};

export default quickLoginService;
